import React from 'react';
import styled from 'styled-components';
import MultiLine from 'components/Graphs/MultiLine/MultiLine.jsx';
import { MultiLineCustomTooltip } from 'components/Graphs/GraphHelpers.js';
import ErrorEntityLineChart from 'components/Pages/Reports/ErrorStates/ErrorEntityLineChart.jsx';

const LineGraphContainer = styled.div`
  padding: 65px 30px 30px 30px;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.06);
  border-radius: 5px;
`;

const EntityLineChart = ({ data, entities, height }) => {
  const grid = { vertical: true, horizontal: true };
  if (!data.length) {
    return (
      <LineGraphContainer>
        <ErrorEntityLineChart />
      </LineGraphContainer>
    );
  }

  return (
    <LineGraphContainer>
      <MultiLine
        height={height || '600px'}
        pctWidth="max"
        data={data}
        xaxis="time"
        grid={grid}
        showXAxis
        showYAxis
        graphToolTip={MultiLineCustomTooltip}
        entities={entities}
        legendOnTop
      />
    </LineGraphContainer>
  );
};

export default EntityLineChart;
